// extracted by mini-css-extract-plugin
export default {"title":"surfaces_title__QlgHn","actionButton":"surfaces_actionButton__wZRrR","disabledRow":"surfaces_disabledRow__jovjw","button":"surfaces_button__3X++k"};